import styled from 'styled-components';

export const LabelTab = styled.label`
  margin: 0;
  font-size: 0.7rem;
  font-weight: 600;
  color: #33333390;
  cursor: pointer;
  padding: 0 10px;
`;
